/* eslint no-underscore-dangle: ["error", { "allow": ["_showInstructions",
"_permissionsTypes"] }] */
// import _ from 'lodash';
import assign from 'object-assign';
import { EventEmitter } from 'events';
// import AppDispatcher from '../dispatcher/AppDispatcher';
// import Constants from '../constants/Constants';

// const ActionTypes = { Constants };

const CHANGE_EVENT = 'change'; // globālais
const _permissionsTypes = [
  'geolocation',
  'audio',
  'camera',
];

const _showInstructions = [];

// tiek pieņemts, ka localStorage satur objektu, kura struktūra ir šāda:
// {
//    geolocation: 0,
//    notification: 1,
//    camera: 2
// }
// attiecīgi atslēga ir atļaujas tips (geolocation, camera, audio etc.) un vērtība
// ir:
//  0 - nav pieprasīta
//  1 - atļauta
//  2 - bloķēta
const PermissionsStore = assign({}, EventEmitter.prototype, {
  emitChange() {
    this.emit(CHANGE_EVENT);
  },

  /**
  * @param {function} callback
  */
  addChangeListener(callback) {
    this.on(CHANGE_EVENT, callback);
  },

  /**
  * @param {function} callback
  */
  removeChangeListener(callback) {
    this.removeListener(CHANGE_EVENT, callback);
  },

  showInstructions(type) {
    if (this.isInstructionsShown(type)) {
      return;
    }
    _showInstructions.push(type);
    this.emitChange();
  },

  isInstructionsShown(type) {
    if (_showInstructions.indexOf(type) === -1) {
      return false;
    }

    return true;
  },

  hideInstructions(type) {
    const index = _showInstructions.indexOf(type);
    _showInstructions.splice(index, 1);
    this.emitChange();
  },

  getShownInstructions() {
    return _showInstructions;
  },

  set(type, value) {
    localStorage['permissions-' + type] = value; // eslint-disable-line prefer-template

    this.emitChange();
  },

  get(type) {
    const val = localStorage['permissions-' + type]; // eslint-disable-line prefer-template
    if (typeof val === 'undefined') {
      return 0;
    }
    return parseInt(val, 10);
  },

  getAll() {
    const result = {};
    _permissionsTypes.forEach(function (type) { // eslint-disable-line func-names, prefer-arrow-callback, max-len
      result[type] = localStorage['permissions-' + type]; // eslint-disable-line prefer-template
      if (typeof result[type] === 'undefined') {
        result[type] = 0;
      }
    });

    return result;
  },
});

module.exports = PermissionsStore;
